import { useEffect, useState } from "react";
import api from "@/lib/api";
import { X } from "lucide-react";

export default function LegalPostModal({ open, slug, fallbackTitle, onClose }) {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(fallbackTitle || "");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (!open || !slug) return;

    let mounted = true;

    (async () => {
      try {
        setLoading(true);
        setTitle(fallbackTitle || "");
        setContent("");

        const res = await api.get(`/posts/${slug}`);

        if (mounted) {
          setTitle(res.data.title || fallbackTitle || "");
          setContent(res.data.content || "");
        }
      } catch (e) {
        console.error(`Failed to load post: ${slug}`, e);

        if (mounted) {
          setTitle(fallbackTitle || "");
          setContent("Conținutul nu a putut fi încărcat momentan.");
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, [open, slug, fallbackTitle]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl max-h-[85vh] overflow-hidden rounded-2xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-black/10 px-6 py-4">
          <h3 className="text-xl font-semibold text-[var(--text-primary)]">
            {title}
          </h3>

          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-2 hover:bg-black/5 transition-colors"
            aria-label="Închide"
          >
            <X className="w-5 h-5 text-[var(--text-primary)]" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-5 max-h-[calc(85vh-80px)]">
          {loading ? (
            <p className="text-[var(--text-muted)]">Se încarcă...</p>
          ) : (
            <div
              className="prose max-w-none text-[var(--text-primary)]"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </div>
    </div>
  );
}